import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import translate from "@insite/client-framework/Translate";
import { StyledButton } from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps, GridOffset, GridWrapper } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridItemStyle, GridWidths } from "@insite/mobius/GridItem";
import { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { TypographyProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { MappedLink } from "@nishtech/Overrides/Widgets/Header/MainNavigation";
import CustomApplicationState from "@nishtech/Store/Nishtech/Data/CustomApplicationState/CustomApplicationState";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

export interface BrandSectionStyles {
    brandsContainer: GridContainerProps;
    brandsFirstGridItem: GridItemProps;
    brandsSecondGridItem: GridItemProps;
    brandsImageGridItem: GridItemProps;
    leftMegaMenuItem?: GridItemProps;
    leftMegaMenuLink: LinkPresentationProps;
}

export const brandSectionStyles: BrandSectionStyles = {
    brandsContainer: {
        css: css`
            height: auto;
            > ${GridOffset} {
                min-height:300px;
                height: auto;
                width: 100%;
                margin: auto;
                flex-wrap: nowrap;
                ${({ theme }: { theme: BaseTheme; }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    null,
                    css`
                            // padding: 0px 9%;
                        `,
                ])}
            }
        `,
    },
    brandsFirstGridItem: {
        css: css`
            padding: 0px;
            max-width: 17%;
            flex-basis: 17%;
            flex-direction: column;
            overflow: hidden auto;
            > li {
                max-width: 100%;
                padding: 0px 15px 10px;
                margin-left: 5px;
                font-size: 12px;
                height: 28px;
                max-height: 28px;
            }
        `,
    },
    brandsSecondGridItem: {
        css: css`
            max-width: 83%;
            flex-basis: 83%;
            padding: 0px 11px;
            overflow: hidden auto;
        `,
    },
    brandsImageGridItem: {
        css: css`
            flex-basis: 100%;
            max-width: 100%;
            padding: 0px;
            flex-direction: row;
            gap: 10px;
            > div:first-child {
                flex-basis: 76%;
                max-width: 76%;
                ${GridWrapper} {
                    width: 100%;
                    ${GridOffset} {
                        display: flex;
                        flex-direction: row;
                        flex-wrap: wrap;
                        margin: 0;
                        width: calc(100% + 10px);
                        margin-left: -5px;

                        @media screen and (max-width: 768px) {
                            width: 100%;
                        }

                        > ${GridItemStyle} {
                            padding: 0;
                            margin: 0 5px 10px 5px;
                            border: solid 1px ${getColor("common.border")};
                            background-color: ${getColor("common.background")};
                            width: calc(100% / 5 - 10px);
                            float: none;
                            min-height: 70px;
                            max-height: 70px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            cursor: pointer;
                            border-radius: 3px;
                            flex-basis: auto;
                            max-width: 100%;
                            > a {
                                padding: 10px !important;
                                width: 100%;
                                height: 100%;
                                display: flex !important;
                                justify-content: center;
                                align-items: center;
                                position: relative;
                                text-transform: initial;
                                img {
                                    width: 100%;
                                    height: 100%;
                                    object-fit: contain;
                                }
                            }

                            &:hover {
                                border: 1px solid ${getColor("text.main")};
                            }
                        }
                    }
                }
            }
            > div:last-child {
                flex-basis: 24%;
                max-width: 24%;
                a {
                    font-size: 14px;
                    line-height: normal;
                    letter-spacing: normal;
                    color: ${getColor("secondary")};
                    text-decoration: none;
                    text-transform: uppercase;
                    font-weight: 600;
                    img {
                        max-width: 225px;
                        height: 150px;
                    }
                }
            }
        `,
    },
    leftMegaMenuLink: {
        css: css`
            > span {
                color: ${getColor("text.main")} !important;
                font-weight: 400 !important;
                padding-top:5px;
            }
            &:hover {
                > span {
                    text-decoration: underline;
                }
            }
        `,
    },
};

interface OwnProps {
    link: MappedLink;
    onHandleClose: Function;
    zoneId: string;
}

const mapStateToProps = (state: CustomApplicationState) => {
    return {
    };
};

const mapDispatchToProps = {
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const BrandSectionComponent = ({
    link,
    onHandleClose,
    zoneId,
}: Props) => {
    const [activeChildIndex, setActiveChildIndex] = useState<number | null>(null);
    const handleMouseEnter = (index: number, categoryName: string) => {
        setActiveChildIndex(index);
    };

    useEffect(() => {
        const childLinks = document.querySelectorAll(".child-link");
        const handleLinkClick = () => {
            onHandleClose();
        };
        childLinks.forEach(link => {
            link.addEventListener("click", handleLinkClick);
        });

        return () => {
            childLinks.forEach(link => {
                link.removeEventListener("click", handleLinkClick);
            });
        };
    }, []);

    const handleMouseLeave = () => {
        setActiveChildIndex(null);
    };
    const styles = brandSectionStyles;

    const brandsCategoryArr: MappedLink[] = [];
    const recursiveArray = (item: MappedLink) => {
        if (item.children && item.children.length > 0) {
            item.children[0];
        }
        if (!item.excludeFromNavigation) {
            brandsCategoryArr.push(item);
        }
    };
    link.children &&
        link.children.forEach((item: MappedLink) => {
            recursiveArray(item);
        });

    useEffect(() => {
    }, []);

    const updateNishtechExclusiveUrl = (url: string) => {
        if (url && url == "/catalog/adi-exclusive") {
            return "/catalog/featured-brands/adi-exclusive";
        } else {
            return url;
        }
    };

    return (
        <GridContainer {...styles.brandsContainer}>
            <GridItem {...styles.brandsFirstGridItem}>
                {brandsCategoryArr.map((child: MappedLink, childIndex: number) => (
                    <React.Fragment key={`${childIndex}-${child.title}`}>
                        <GridItem
                            className="brand-mega-menu-left-grid-item"
                            {...styles.leftMegaMenuItem}
                            width={(12 / link.numberOfColumns!) as GridWidths}
                            key={`${childIndex}${child.title}`}
                            onMouseOver={() => handleMouseEnter(childIndex, child.title)}
                            onMouseLeave={handleMouseLeave}
                            as="li"
                        >
                            <Link
                                className="brand-mega-menu-left-link"
                                {...styles.leftMegaMenuLink}
                                href={updateNishtechExclusiveUrl(child.url)}
                                data-category-name={`selectedCategoryName_${child.title}`}
                                onClick={() => onHandleClose()}
                            >
                                {child.title}
                            </Link>
                        </GridItem>
                    </React.Fragment>
                ))}
            </GridItem>
            <GridItem {...styles.brandsSecondGridItem}>
                <GridItem {...styles.brandsImageGridItem}>
                    <Zone zoneName="brands" contentId={zoneId}></Zone>
                    <Zone zoneName="advertising" contentId={zoneId}></Zone>
                </GridItem>
            </GridItem>
        </GridContainer>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(BrandSectionComponent);
